import { Components, menuClasses, Theme } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiMenu to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/menu#css
 */
export const MuiMenu: Components<Theme>['MuiMenu'] = {
  defaultProps: {
    PaperProps: {
      elevation: 1,
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
      [`& .${menuClasses.paper}`]: {
        minWidth: '161px',
        backgroundColor: theme.palette.background.default,
      },
    }),
  },
};
